import { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Modal } from 'bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useToast } from '../../toastHook'
import { comparer } from '../../utils/comparer'
import { errorCss } from '../Utils/formik-util';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmModalComponent } from '../Utils/ConfirmModal';

export const ActiviteAssocieeComponent = () => {
    const { display } = useToast();
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false);
    const [rows, setRows] = useState([]);
    const [nbModifs, setNbModifs] = useState(0);
    const [activiteToInsert, setActiviteToInsert] = useState('');
    const [toRemoveActivite, setToRemoveActivite] = useState('');
    const [toRemoveActiviteAssociee, setToRemoveActiviteAssociee] = useState('');
    const [activites, setActivites] = useState([]);

    const modalRefInsert = useRef();

    useEffect(() => {
        axios.get('/api/activite/getall').then(response => {
            let tmpActivites = response.data.map(x => { return { value: x } }
            );
            tmpActivites.sort((x, y) => comparer(x.value, y.value));
            setActivites(tmpActivites)
        })
    }, []);

    useEffect(() => {
        axios.get('/api/activiteassociee/get')
            .then(response => {
                if (response.data) {

                    let tmpRows = [];

                    for (const key in response.data) {
                        const values = response.data[key];

                        const tmpValues = values.map(x => {
                            return {
                                key: key + '-' + x,
                                data: {
                                    activite: key,
                                    activiteAssociee: x
                                }
                            }
                        })

                        tmpRows.push({
                            key: key,
                            data: {
                                activite: key,
                                activiteAssociee: '',
                            },
                            children: tmpValues
                        });
                    }

                    setRows(tmpRows);
                }
            });
    }, [nbModifs]);

    const insertFormValidationSchema = Yup.object().shape({
        activiteAssociee: Yup.string()
            .required('Requis')
            .oneOf(activites.map(x => x.value), 'activité incorrecte')
            .test((value, { createError }) => value === activiteToInsert ? createError({ message: "l'activité doit être différente de l'activité associée"}) : true)
    });

    const insertFormik = useFormik({
        initialValues: {
            activiteAssociee: ''
        },
        validationSchema: insertFormValidationSchema,
        onSubmit: values => {


            const activite = activiteToInsert;
            axios.get('/api/activiteassociee/add?activite=' + encodeURI(activiteToInsert) + '&activiteAssociee='+ encodeURI(values.activiteAssociee)).then(response => {
                if (response.status === 200) {

                    display({
                        titre: 'compétence liée ajouté',
                        text: `l'activité associée '${values.activiteAssociee}' a été ajouté à l'activité ${activite}`,
                        severity: 'success'
                    });

                    setNbModifs(nbModifs + 1);
                }
                else {
                    display({
                        titre: 'activité associée non ajouté',
                        text: `l'activité associée '${values.activiteAssociee}' n'a pas pu être ajouté à l'activité' ${activite}`,
                        severity: 'danger'
                    })
                }
            });


            const modal = Modal.getOrCreateInstance(modalRefInsert.current);
            modal.hide();
        }
    });

    const templateButton = x => {
        if (x.data.activiteAssociee) {
            return <div>
                <i className="pi pi-times-circle text-danger" onClick={() => {
                    setToRemoveActivite(x.data.activite);
                    setToRemoveActiviteAssociee(x.data.activiteAssociee);

                    setOpenConfirmRemoveModal(true);
                }} ></i></div>
        }
        else {
            return <div><i className="pi pi-plus text-success" onClick={() => {
                setActiviteToInsert(x.data.activite);

                insertFormik.resetForm();

                const modal = Modal.getOrCreateInstance(modalRefInsert.current);
                modal.show();

            }} ></i ></div >
        }
    }

    const removeActiviteAssociee = () => {
        axios.get('/api/activiteassociee/remove?activiteAssociee=' + encodeURI( toRemoveActiviteAssociee ) + '&activite=' + encodeURI(toRemoveActivite)).then(response => {
            if (response.status === 200) {

                display({
                    titre: 'activité associée retiré',
                    text: `l'activité associée '${toRemoveActiviteAssociee}' a été retiré à l'activité ' ${toRemoveActivite}`,
                    severity: 'success'
                });

                setNbModifs(nbModifs + 1);
            }
            else {
                display({
                    titre: 'activité associée non retiré',
                    text: `l'activité associée '${toRemoveActiviteAssociee}' n'a pas pu être retiré à l'activité ' ${toRemoveActivite}`,
                    severity: 'danger'
                })
            }
        });
    }

    return <div>
        <div className="alert alert-info">
            Voici le liste des activités associées de la plateforme. <br />

            Pour comprendre la notion d'activité associée: supposons l'activité X associé à Y <br></br>
            Toto a été Y pendant 10 ans et X pendant 5 ans (sans être Y) <br></br>
            toto aura une expérience Y de 15 ans et une expérience X de 5 ans<br></br>

        </div>
        <TreeTable value={rows} sortMode="multiple" >
            <Column field="activite" sortable header="Activité" filter expander></Column>
            <Column field="activiteAssociee" sortable header="Activité Associée" filter></Column>
            <Column body={templateButton} />
        </TreeTable>
        <div ref={modalRefInsert} className="modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter une activité liée</h5>
                    </div>
                    <form onSubmit={insertFormik.handleSubmit}
                    >
                        <div className="modal-body"  >
                            <div className="alert alert-info">Vous allez ajouter une activité associée à l'activité' <b>{activiteToInsert}</b></div>
                            <div className="form-group">
                                <label htmlFor="activiteAssociee">Activité associée</label>
                                {/*<Dropdown onChange={insertFormik.handleChange}*/}
                                {/*    name="activiteAssociee" value={insertFormik.values.activiteAssociee} options={activites} optionLabel="value" optionValue="value" placeholder="Sélectionner une activité"*/}
                                {/*    filter className={`form-control ${errorCss(insertFormik.errors.activiteAssociee)}`} />*/}
                                <input list="activites-list" className={`form-select ${errorCss(insertFormik.errors.activiteAssociee)}`} onChange={insertFormik.handleChange} value={insertFormik.values.activiteAssociee} name="activiteAssociee" />
                                <datalist id="activites-list">
                                    {activites.map(x => <option key={x.value} value={x.value} />)}
                                </datalist>
                                {insertFormik.errors.activiteAssociee ? (
                                    <div className="invalid-feedback">{insertFormik.errors.activiteAssociee}</div>
                                ) : (<></>)}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success"  >Valider</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <ConfirmModalComponent open={openConfirmRemoveModal} setOpen={setOpenConfirmRemoveModal} titre="êtes vous sure de supprimer ?" message={`Vous allez supprimer l'activité associée '${toRemoveActiviteAssociee}' pour l'activité '${toRemoveActivite}' , êtes-vous sure ? `} onConfirm={removeActiviteAssociee} />
    </div>
}





